// extracted by mini-css-extract-plugin
export default {"error-container":"NotFoundPage_error-container__D9AMK"};